import styled from "styled-components";

export const Container = styled.div`
	@media screen and (min-width: 0px) {
		flex: 1 1 auto;
		display: flex;
		flex-direction: column;

		section:nth-of-type(1) {
			flex: 1 1 auto;
			display: flex;
			flex-direction: column;
			justify-content: center;
		}

		section.about {
			width: 100%;
			min-height: 192px;
			background-image: url(${require("@/assets/img/gato.png").default});
			background-size: cover;

			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;

			.content {
				display: flex;
				flex-direction: column;
				align-items: center;

				h2 {
					font-family: "PFSquareSansProBold", sans-serif;
					margin-top: 0;
					font-size: 2.625em;
					font-weight: 900;
					color: var(--white);
					margin-bottom: 1.5rem;
				}

				a {
					display: block;
					max-width: 153px;
					color: var(--white);
					text-decoration: none;
					border: 1px solid var(--white);
					padding: 0.75em 2em;
					transition: all 0.3s;

					&:hover {
						background-color: var(--white);
						color: var(--primary-color);
					}
				}
			}
		}

		.content {
			margin-bottom: 3em;
			margin-top: 2em;

			header {
				display: flex;
				flex-direction: column-reverse;
				margin-top: 2em;

				h1 {
					margin-top: 0;
				}

				p {
					margin-top: 0;
					margin-bottom: 0.313em;
				}
			}
		}
	}

	@media screen and (min-width: 992px) {
		.content {
			header {
				h1 {
					font-size: 2.375em;
				}
			}
		}

		section.about {
			min-height: 300px;
			background-image: url(${require("@/assets/img/gato@3x.png")
				.default});

			.content {
				align-items: flex-start;
				margin-left: 15vw;

				h2 {
					font-size: 3.75em;
					margin-bottom: 1.5rem;
				}
			}
		}
	}
`;
